"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trimString = void 0;

var trimString = function trimString(stringToTrim, charToRemove, side) {
  if (side === 'start') {
    while (stringToTrim.charAt(0) == charToRemove) {
      stringToTrim = stringToTrim.substring(1);
    }
  } else {
    while (stringToTrim.charAt(stringToTrim.length - 1) == charToRemove) {
      stringToTrim = stringToTrim.substring(0, stringToTrim.length - 1);
    }
  }

  return stringToTrim;
};

exports.trimString = trimString;